import mapProps from '../scripts/utils/map-props';
import Transfer from './transfer';

export default mapProps(
  [
    {
      name: 'value',
      alias: ['values'],
    },
    'selectedKeys',
    {
      name: 'filterable',
      alias: ['searchFlag'],
    },
  ],
  {
    model: {
      prop: 'value',
      event: 'change',
    },
  }
)(Transfer);
